import React, { useState, useEffect } from 'react'
import { HeadingSeperateLine, ContainerHeading, Title, Icon } from './styled'
import gsap from 'gsap'
import { SplitText } from 'gsap/dist/SplitText'
import PlanningStepOne from '../FormSteps/PlanningStepOne'
import PlanningStepTwo from '../FormSteps/PlanningStepTwo'
import DetailsStep from '../FormSteps/DetailsStep'
import { Response, ConfirmationWrapperMobile } from '../styled'

type Input = {
  value: string | boolean | number
  setValue: (newValue) => void
  error?: boolean
}

interface otherDataProps {
  values: (string | number)[]
}

export interface formDataProps {
  title: string
  transitionType: string
  iconVariant: string
  noLine: boolean
  input: Input[]
  formStepName: string
}

const isServer = typeof window === 'undefined'
let isMobile = false
if (!isServer) {
  if (document.documentElement.clientWidth <= 960) {
    isMobile = true
  }
}
const FormStep: React.FC<{
  formData: formDataProps
  otherData?: otherDataProps
  variant: string
  noWeekend: boolean
}> = ({
  variant,
  otherData,
  noWeekend,
  formData: { formStepName, title, transitionType, iconVariant, noLine, input },
}) => {
  const CheckmarkIcon = () => {
    const checkmarkFillColor = variant === 'light' ? '#337f65' : '#ffffff'
    const circleStrokeColor = variant === 'light' ? '#000000' : '#337f65'
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 0 211.624 211.624"
      >
        <path
          id="Rectangle_8_copy_3"
          data-name="Rectangle 8 copy 3"
          fill={checkmarkFillColor}
          fillRule="evenodd"
          d="M419.582,616.3l-8.379-8.38-42.554,42.554L344.3,626.118l-8.379,8.379L368.5,667.083Z"
          transform="translate(-270.188 -528.188)"
        />
        <circle
          fill="none"
          stroke={circleStrokeColor}
          strokeWidth="10px"
          cx="105.812"
          cy="105.812"
          r="100.812"
        />
      </svg>
    )
  }
  // const formData = source[formStepId]
  const lineRef = React.useRef()
  const iconRef = React.useRef()
  const titleRef = React.useRef()
  const [tl, setTl] = useState(null)
  const [titleSTRef, setTitleSTRef] = useState(null)

  useEffect(() => {
    if (!titleSTRef || !iconRef || !lineRef) {
      return
    }
    const charsOfLinesTitle = titleSTRef.lines.map(
      (line) =>
        new SplitText(line, {
          charsClass: 'char',
          type: 'chars',
        }).chars,
    )

    charsOfLinesTitle.forEach((chars) => {
      tl.fromTo(
        chars,
        1.0,
        {
          y: 115,
        },
        {
          force3D: true,
          ease: 'circ.out',
          stagger: 0.02,
          y: 0,
        },
        0,
      )
    })
    tl.fromTo(
      iconRef.current,
      1,
      { opacity: 0, y: -2, x: -5 },
      { opacity: 1, y: 0, x: 0, ease: 'circ.out' },
      0.5,
    )

    tl.fromTo(
      lineRef.current,
      1.0,
      { width: '0%' },
      { width: '100%', ease: 'circ.out' },
      0,
    )
  }, [titleSTRef, iconRef, lineRef])

  useEffect(() => {
    if (transitionType === 'transitionIn') {
      setTl(gsap.timeline({ repeat: 0 }))

      setTitleSTRef(
        new SplitText(titleRef.current, {
          linesClass: 'line',
          type: 'lines',
        }),
      )
    }
  }, [])

  return (
    <>
      {(formStepName !== 'confirm' || !isMobile) && (
        <>
          <ContainerHeading variant={variant} noLine={noLine}>
            <Title ref={titleRef}>{title}</Title>
            <Icon variant={iconVariant} ref={iconRef} />
          </ContainerHeading>
          <HeadingSeperateLine ref={lineRef} />
        </>
      )}
      {formStepName === 'planner1' && (
        <PlanningStepOne
          noWeekend={noWeekend}
          variant={variant}
          input={input}
        />
      )}
      {formStepName === 'planner2' && (
        <PlanningStepTwo
          variant={variant}
          input={input}
          month={otherData[0]}
          day={otherData[1]}
        />
      )}
      {formStepName === 'details' && (
        <DetailsStep variant={variant} input={input} />
      )}
      {formStepName === 'confirm' && isMobile && (
        <ConfirmationWrapperMobile>
          <CheckmarkIcon variant={variant} />
          <Response>
            We’ll get in contact as soon as possible via email.
          </Response>
        </ConfirmationWrapperMobile>
      )}
      {formStepName === 'confirm' && !isMobile && (
        <Response>We’ll get in contact as soon as possible via email.</Response>
      )}
    </>
  )
}

export default FormStep
